import React from 'react';
import NewsletterV2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/NewsletterV2';

const Subscribe = () => {
  return (
    <NewsletterV2
      text={{
        title: 'Get the most out of your new Bitcoin wallet',
        subtitle: 'Subscribe to Bitcoin.com App updates to learn more…',
        button: 'Sign up',
      }}
      subscribeTo={['email_updates']}
      redirectUrl="https://branch.wallet.bitcoin.com/xafKYCQw3Cb"
    />
  );
};

export default Subscribe;
